const STATS = [
  { label: '每日更新综艺', value: '50+' },
  { label: '高清流畅播放', value: '1080P' },
  { label: '覆盖综艺类型', value: '20+' },
];

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20artistic%20entertainment%20stage%20with%20colorful%20dynamic%20spotlights%20flowing%20across%20a%20dark%20dramatic%20background%20warm%20orange%20golden%20amber%20tones%20modern%20digital%20art%20style%20cinematic%20atmosphere%20with%20flowing%20energy%20waves%20and%20soft%20gradients%20luxurious%20broadcast%20studio%20vibe&width=1920&height=1080&seq=hero-bg-6789&orientation=landscape"
          alt="6789影视综艺舞台背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-24">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-white text-xs md:text-sm font-semibold rounded-full mb-5 whitespace-nowrap tracking-wide">
              热门搞笑真人秀免费全集
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-white leading-tight mb-4 tracking-tight">
              6789影视
              <span className="block text-xl md:text-2xl lg:text-3xl font-semibold text-white/85 mt-2 font-body">
                综艺在线观看与最新综艺平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-white/80 mb-1 font-normal leading-relaxed max-w-xl mx-auto lg:mx-0">
              每日更新热门综艺、搞笑综艺、真人秀综艺免费全集在线观看，高清流畅不缓冲。
            </p>
            <p className="text-sm md:text-base text-white/80 mb-6 font-normal leading-relaxed max-w-xl mx-auto lg:mx-0">
              从音乐竞演到推理探案，从治愈慢综到爆笑真人秀，覆盖全网热门综艺类型，紧跟每期精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {STATS.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-black text-accent-400">
                    {s.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/65 mt-0.5 whitespace-nowrap">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all text-center"
              >
                浏览专题合集
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-white/30 transition-all text-center border border-white/25"
              >
                查看热度榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20variety%20show%20stage%20with%20vibrant%20colorful%20LED%20screens%20and%20dramatic%20lighting%20modern%20entertainment%20broadcast%20studio%20warm%20golden%20orange%20highlights%20professional%20production%20atmosphere%20cinematic%20composition%20with%20depth%20and%20energy&width=960&height=720&seq=hero-visual-6789&orientation=landscape"
                alt="6789影视综艺精彩集锦"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-white/15 pointer-events-none"></div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-5">
                <div className="flex items-center gap-2 text-white/90 text-xs">
                  <i className="ri-play-circle-fill text-accent-400 text-lg"></i>
                  <span className="font-medium whitespace-nowrap">海量综艺 · 每日更新 · 高清流畅</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}